export function crmFormField() {
  return {
    restrict: 'E',
    template: require('./crm-form-field.directive.html'),
    scope: {
      entry: '=',
      organization: '<',
    },
    controller: controller,
  };
}

controller.$inject = ['$scope'];
function controller($scope) {
  $scope.contactFieldsByName = {};

  $scope.organization.object_description[
    $scope.organization.configuration.contact_object_name
  ].fields.forEach((field) => ($scope.contactFieldsByName[field.name] = field));
  $scope.searchTerm = "";
}
